import {
  Slot,
  component$,
  useStore,
  useContextProvider,
  createContextId,
  $,
} from "@builder.io/qwik";
import type { ColorsActionType, ColorsType } from "../types/ColorsType";

const initData: ColorsType = {
  background: "rgba(0, 0, 0, 0)",
  grid: "#222631",
  tick: "#b2b5be",
  selectorLine: "rgba(178,181,190,0.5)",
  selectorLabelBackground: "#2a2e39",
  selectorLabelText: "#b2b5be",
  redCandle: "#089981",
  greenCandle: "#e13443",
  greenVolumeCandle: "rgba(8, 153, 129, 0.5)",
  redVolumeCandle: "rgba(225, 52, 67, 0.5)",
  longPosition: "#fff",
  shortPosition: "#fff",
  sl: "#F9DB04",
  tp: "#04F5F9",
  RSChartStroke: "#04F5F9",
  RSChartOverlay: "#000",
  RSChartOverlayResize: "#e13443",
  resetButtonColor: "#04F5F9",
};

export const ColorsContext = createContextId<ColorsType>("ColorsContext");
export const ColorsDispatchContext = createContextId<
  (action: ColorsActionType) => void
>("ColorsDispatchContext");

function colorsReducer(state: ColorsType, action: ColorsActionType) {
  if (action.type === "changeColors") {
    state.background = action.colorPalette.background
      ? action.colorPalette.background
      : state.background;
    state.grid = action.colorPalette.grid
      ? action.colorPalette.grid
      : state.grid;
    state.tick = action.colorPalette.tick
      ? action.colorPalette.tick
      : state.tick;
    state.selectorLine = action.colorPalette.selectorLine
      ? action.colorPalette.selectorLine
      : state.selectorLine;
    state.selectorLabelBackground = action.colorPalette.selectorLabelBackground
      ? action.colorPalette.selectorLabelBackground
      : state.selectorLabelBackground;
    state.selectorLabelText = action.colorPalette.selectorLabelText
      ? action.colorPalette.selectorLabelText
      : state.selectorLabelText;
    state.redCandle = action.colorPalette.redCandle
      ? action.colorPalette.redCandle
      : state.redCandle;
    state.greenCandle = action.colorPalette.greenCandle
      ? action.colorPalette.greenCandle
      : state.greenCandle;
    state.longPosition = action.colorPalette.longPosition
      ? action.colorPalette.longPosition
      : state.longPosition;
    state.shortPosition = action.colorPalette.shortPosition
      ? action.colorPalette.shortPosition
      : state.shortPosition;
    state.sl = action.colorPalette.sl ? action.colorPalette.sl : state.sl;
    state.tp = action.colorPalette.tp ? action.colorPalette.tp : state.tp;
    state.RSChartStroke = action.colorPalette.RSChartStroke
      ? action.colorPalette.RSChartStroke
      : state.RSChartStroke;
    state.RSChartOverlay = action.colorPalette.RSChartOverlay
      ? action.colorPalette.RSChartOverlay
      : state.RSChartOverlay;
    state.RSChartOverlayResize = action.colorPalette.RSChartOverlayResize
      ? action.colorPalette.RSChartOverlayResize
      : state.RSChartOverlayResize;
    state.resetButtonColor = action.colorPalette.resetButtonColor
      ? action.colorPalette.resetButtonColor
      : state.resetButtonColor;
  }
}

export const ColorsProvider = component$(() => {
  const data = useStore({ ...initData });
  const dispatch = $((action: ColorsActionType) => {
    colorsReducer(data, action);
  });
  useContextProvider(ColorsContext, data);
  useContextProvider(ColorsDispatchContext, dispatch);
  return <Slot />;
});

export const getColors = ColorsContext;
export const getColorsDispatch = ColorsDispatchContext;
